import { defineMessages } from 'react-intl';

export const freightBrowserContainerMessages = defineMessages({
  noShipFromSelected: {
    id: 'g4K8kP',
    description: 'Error shown when no ship from warehouse is selected',
    defaultMessage: 'No Ship From Warehouse has been selected.',
  },
  failedToRetrieveQuotes: {
    id: '9ElxZE',
    description: 'Error shown when the freight quote request returns no usable quotes',
    defaultMessage: 'Failed to retrieve quotes.',
  },
  rateFetchError: {
    id: 'prvC/m',
    description: 'Generic error shown when an unexpected error occurs while fetching freight rates',
    defaultMessage: 'An error occurred while fetching rates.',
  },
  quoteTimedOut: {
    id: 'v2GfPN',
    description: 'Error shown when freight quote request times out waiting for Pusher response',
    defaultMessage: 'Quote request timed out. Please try again.',
  },
  saveQuoteFailed: {
    id: 'uJ/nCL',
    description: 'Fallback error shown in a notification when saving a freight quote fails without a server message',
    defaultMessage: 'Failed to save quote.',
  },
  saveQuoteSuccess: {
    id: 'NB7+v2',
    description: 'Content of the notification shown when a freight quote is saved successfully',
    defaultMessage: 'Saved quote.',
  },
  commodityWeightRequired: {
    id: '+/1kJz',
    description: 'Error shown when a handling unit commodity has no weight entered before browsing rates',
    defaultMessage: 'All commodities must have a weight greater than zero.',
  },
  addShipFromSuccess: {
    id: 'eLnO02',
    description: 'Success notification shown after a new ship-from location is created from the freight rate browser',
    defaultMessage: 'Ship from location added.',
  },
  handlingUnitHeightRequired: {
    id: 'BneUnm',
    description: 'Error shown when a handling unit has no height entered before browsing rates',
    defaultMessage: 'All handling units must have a height greater than zero.',
  },
  commodityFreightClassRequired: {
    id: 'WZ631e',
    description: 'Error shown when a commodity has no freight class selected before browsing rates',
    defaultMessage: 'All commodities must have a freight class selected.',
  },
});
